import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const AccountInfoModalAccountFragmentDoc = gql`
  fragment AccountInfoModalAccount on Account {
    id
    code
    name
    description
    parent {
      id
      name
    }
  }
` as unknown as DocumentNode<Types.AccountInfoModalAccountFragment, unknown>
